import { useState, useEffect, useCallback } from 'react';
import { useQuery } from 'react-query';


// @mui
import { Grid, Card, Stack, Typography, Paper } from '@mui/material';

import { getSysInfo } from '../api/sysApi';
import MessageMarkdown from './MessageMarkdown';


// ----------------------------------------------------------------------

export default function Infography({ id }) {
    // Fetch Data
    const qData = useQuery({
        queryKey: ['sysInfo', id], queryFn: async () => {
            const d = await getSysInfo(id);
            if (d.data) return d.data;
            return [];
        }, refetchOnWindowFocus: false,
    });


    // qData?.isError(e =>{
    //     window.location.href = '/'
    // })

    // const richText = (text) => {
    //     const regex = /\*(.*?)\*/g;
    //     return text.replace(regex, '<strong>$1</strong>');
    //   };

    return (
        <>
            {
                qData?.data?.map(i =>
                    <div key={i.id} >
                        <div style={{fontWeight:700}}>
                            {i.title}
                        </div>
                        
                        <MessageMarkdown sx={{ fontWeight: 500 }}>{i.description}</MessageMarkdown>
                       
                    </div>)
            }

        </>
    );
}
